import axios from "axios";
import { useQuery } from "react-query";
import { ROSTER_ENDPOINT } from "../madSettings";

/**
 * MAD's allocation feed: every active (volunteer, child) allocation,
 * narrowed by whichever of the filters are about the volunteer (Volunteer
 * Name and the MAD Role / Centre / Chapter / City / State / Country rollups;
 * the endpoint does the translating). More than one part of the widget
 * reads it (the stats bar's denominator, the Not started list); each calls
 * this itself with the same filters, and react-query serves the second
 * caller from the first one's result.
 */
export const useRoster = (filters = []) =>
  useQuery(
    ["madAllChildren", filters],
    () => axios.post(ROSTER_ENDPOINT, { activeFilters: filters }).then((res) => res.data.data || []),
    { staleTime: 5 * 60 * 1000 }
  );
